/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business データカタログの表示用フォーマット関数群。バイト数・数値・タイムスタンプを日本語 UI 向けに整形する。
 * @graph-connects none
 */

/** @graph-connects none */
export function formatBytes(bytes: number): string {
  if (bytes === 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / 1024 ** i).toFixed(i > 0 ? 1 : 0)} ${units[i]}`;
}

/** @graph-connects none */
export function formatNumber(n: number): string {
  return n.toLocaleString('ja-JP');
}

/** @graph-connects none */
export function toJstDateTime(iso: string): string {
  const parts = new Intl.DateTimeFormat('ja-JP', {
    timeZone: 'Asia/Tokyo',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date(iso));
  const byType: Record<string, string> = {};
  for (const p of parts) byType[p.type] = p.value;
  return `${byType['year']}/${byType['month']}/${byType['day']} ${byType['hour']}:${byType['minute']}`;
}
